import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetAllCourtsUsageDto } from "../../../models/analytics/dto/get-all-courts-usage.dto";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_ALL_COURTS_USAGE_QUERY_KEY = 'allCourtsUsage';

export const useGetAllCourtsUsage = (locationId: string, startDate: Date, endDate: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_ALL_COURTS_USAGE_QUERY_KEY, locationId, startDate.toISOString(), endDate.toISOString(), filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            return apiClient.fetchApi<GetAllCourtsUsageDto, {}>({
                method: 'GET',
                endpoint: `analytics/all-courts-usage?locationId=${locationId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}${buildFilterSuffix(filters)}`
            });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
